angular.module('tikonApp').constant('ENV', {
    API_BASE_URL: 'http://your-api-url.com'
});
